import React, { useEffect } from 'react'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData } from 'Pages/ReportsAlerts/Reports/@signals'
import { array, object } from 'yup'
import { userData } from '@signals'
import EmailsTagField from 'Pages/ReportsAlerts/Reports/@components/Emails'
import { validateFormat } from '@utils'
import { useComputed } from '@preact/signals-react'


export default function ReportEmailField() {

	const {
		notificationEmail,
		setNotificationEmailInfo,
		error
	} = useReportFormInfo(reportFormData.peek()?.notificationEmail, "notificationEmail", object({ notificationEmail: array() }))
	const isCreating = useComputed(() => !reportFormData.value.title?.includes("Edit"))

	const handleCheckEmailFormat = e => {
		if (e?.every((value) => validateFormat('email', value))) {
			setNotificationEmailInfo(e)
		}
	}

	useEffect(() => {
		if (!notificationEmail?.length && isCreating.value)
			setNotificationEmailInfo(userData.value?.email ? [userData.value?.email] : [])
	}, [])

	return <EmailsTagField
		placeholder='Email address'
		value={notificationEmail || []}
		onChange={handleCheckEmailFormat}
		error={error}
	/>
}